import React, { memo } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";

import { ReactComponent as Icon } from "../../assets/icons/add.svg";

const AddIcon = styled(Icon)(() => ({
  width: "24px",
  height: "24px",
  marginRight: "9px"
}));

const Button = styled("button")(({ theme }) => ({
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  fontSize: "16px",
  fontWeight: 500,
  cursor: "pointer",
  outline: "none",
  padding: "12px 24px",
  backgroundColor: "#fff",
  border: "1px solid #000",
  borderRadius: "100px",
  "&[disabled]": {
    opacity: "0.5"
  }
}));

const Text = styled("span")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  fontStyle: "normal",
  fontStretch: "normal"
}));

/**
 * Base component for add button with optional icon
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.title="Add"] - Button text
 * @param {string} [props.className=""] - Additional CSS class
 * @param {boolean} [props.showIcon=true] - Whether to show the add icon
 * @returns {React.ReactElement} - Rendered button component
 */
const AddButtonBase = ({ title = "Add", className = "", showIcon = true, ...rest }) => (
  <Button className={className} type="button" {...rest}>
    {showIcon && <AddIcon alt="add" />}
    <Text>{title}</Text>
  </Button>
);

AddButtonBase.propTypes = {
  /** Button text */
  title: PropTypes.string,
  /** Additional CSS class */
  className: PropTypes.string,
  /** Whether to show the add icon */
  showIcon: PropTypes.bool
};

export const AddButton = memo(AddButtonBase);
